<template>
  <div class="row w-100 m-0 p-2 d-flex justify-content-center"> 
    <div class="col-md-12 bg-white rounded py-4">
      <time-line class="mt-4" v-if="comments.length > 0">
        <div v-for="(item, index) in comments" :key="index">
          <time-line-item class="custom-time-line rounded">
            <template #icon>
              <em
                class="fas fa-comment radius"              
              />
            </template>           
            <template #date>
              <div class="date-container">
                <div class="color-black font-16 font-weight-bold fulldate">
                  {{ item.createdDate | date }}
                </div>
                <div class="color-black font-12 font-weight-bold hour">
                  {{ item.createdDate | hour }}
                </div>
              </div>
            </template>
            <div class="row mx-1">
              <div class="col col-md-4">
                <div class="color-gray-6 font-14 font-weight-normal">
                  Usuario:
                </div>
                <div class="color-black font-16 font-weight-normal label-value">
                  {{ item.userName | empty }}
                </div>
              </div>
              <div class="col col-md-4">
                <div class="color-gray-6 font-14 font-weight-normal">
                  Nombre:
                </div>
                <div class="color-black font-16 font-weight-normal label-value">
                  {{ item.userFullName | empty }}
                </div>
              </div>
              <div class="col col-md-4">
                <div class="color-gray-6 font-14 font-weight-normal">
                  Documento:
                </div>
                <div class="color-black font-16 font-weight-normal label-value">
                  {{ item.documentName | empty }}
                </div>
              </div>
              <div class="col col-md-12 mt-3">
                <div class="color-gray-6 font-14 font-weight-normal ml">
                  Comentario:
                </div>
                <div
                  class="color-black font-16 font-weight-normal label-value ml"
                >
                  {{ item.comment | empty }}
                </div>
              </div>          
            </div>          
          </time-line-item>
        </div>
      </time-line>
      <custom-result-not-found
        v-else
        class="mt-4 row pt-3"
        text="No hay Información Disponible."
      />
    </div> 
  </div> 
</template>
<script>

import { TimeLine, TimeLineItem } from "@quisit/mipe-timeline";
import CustomResultNotFound from "custom-result-not-found";

export default {
  name: 'DocumentCommentHistory',
  components: {
    TimeLine,
    TimeLineItem,
    CustomResultNotFound
  },
  props: {
    comments: {
      type: Array,
      default: ()=> []
    }
  }      
}

</script>

 